import React, { useState } from "react";
import { useSelector } from "react-redux";

const audits = [
  {
    q: "I'm interested in...",
    sub: "Select all apply",
    type: "m",
    a: [
      ["Lead Generation", 0],
      ["Sales/Ecommerce", 1],
      ["Analytics", 2],
      ["Not Sure / I don't know", 3],
    ],
    o: "",
    s: [false, false, false, false],
  },
  {
    q: "What CRM solution do you use?",
    sub: "",
    type: "s",
    a: [
      ["Active Campaign", 0],
      ["HubSpot", 1],
      ["Salesforce", 2],
      ["Zoho", 3],
      ["Sendgrid", 4],
      ["Drip", 5],
      ["Zendesk", 6],
      ["Aweber", 7],
      ["None", 8],
      ["Other", 9],
    ],
    o: "The CRM solution I use is...",
    s: -1,
  },
  {
    q: "What eCommerce solution(s) do you use?",
    sub: "Select all apply",
    type: "m",
    a: [
      ["WooCommerce", 0],
      ["Shopify", 1],
      ["Bigcommerce", 2],
      ["None", 3],
      ["Other", 4],
    ],
    o: "The eCommerce solution I use is...",
    s: [false, false, false, false, false],
  },
  {
    q: "How do you drive traffic to your website? Select all applies",
    sub: "",
    type: "m",
    a: [
      ["Facebook Ads", 0],
      ["Google Ads", 1],
      ["Affiliate Marketing", 2],
      ["Organic", 3],
      ["None", 4],
      ["Other", 5],
    ],
    o: "I drive traffic to my website using...",
    s: [false, false, false, false, false, false],
  },
  {
    q: "What is your monthly paid traffic budget?",
    sub: "",
    type: "p",
    a: 100000,
    o: "",
    s: 0,
  },
  {
    q: "What is your monthly unique traffic?",
    sub: "",
    type: "p",
    a: 200000,
    o: "",
    s: 0,
  },
  {
    q: "Ever used HandL UTM Grabber before?",
    sub: "",
    type: "s",
    a: [
      ["Yes", 0],
      ["No", 1],
    ],
    o: "",
    s: -1,
  },
  {
    q: "Are you an agency?",
    sub: "",
    type: "s",
    a: [
      ["Yes", 0],
      ["No", 1],
    ],
    o: "",
    s: -1,
  },
  {
    q: "Please fill with your details",
    sub: "",
    type: "f",
    a: [
      ["First Name", 0],
      ["Your Email", 1],
      ["Your Website", 2],
      ["Please accept our", 3],
      ["Terms and conditions", 4],
    ],
    o: "",
    s: ["", "", "", false],
  },
];

const FreeUtmAudit = () => {
  const [aN, setAN] = useState(0);
  const [as, setAs] = useState(audits);
  const [error, setError] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const { isAuthenticated, tmpUser } = useSelector(
    (state) => state.auth.data || {}
  );

  if (isAuthenticated && tmpUser) {
    let newAS = JSON.parse(JSON.stringify(as));
    newAS[8].s[0] = tmpUser.first_name;
    newAS[8].s[1] = tmpUser.email;
    setAs(newAS);
  }

  const PrevClick = () => {
    if (aN > 0) {
      setAN(aN - 1);
    }
  };

  const NextClick = () => {
    if (aN < 8) {
      if (
        as[aN].type == "m" &&
        as[aN].s.filter((data) => data == true).join("") == ""
      ) {
        return;
      }
      if (as[aN].type == "s" && as[aN].s == -1) {
        return;
      }
      setAN(aN + 1);
      return;
    }
    if (
      as[aN].s[0] == "" ||
      as[aN].s[1] == "" ||
      as[aN].s[2] == "" ||
      as[aN].s[3] == false
    ) {
      return;
    }
  };

  const CheckBoxHandler = (e, th) => {
    let newAS = JSON.parse(JSON.stringify(as));
    newAS[aN].s[th] = !newAS[aN].s[th];
    setAs(newAS);
  };

  const CheckTermHandler = (e, th) => {
    let newAS = JSON.parse(JSON.stringify(as));
    newAS[aN].s[th] = !newAS[aN].s[th];
    if (
      newAS[aN].s[0] == "" ||
      newAS[aN].s[1] == "" ||
      newAS[aN].s[2] == "" ||
      newAS[aN].s[3] == false
    ) {
      setError(true);
      setShowModal(false);
    } else {
      setError(false);
      setShowModal(false);
    }
    setAs(newAS);
  };

  const RadioHandler = (e, th) => {
    let newAS = JSON.parse(JSON.stringify(as));
    newAS[aN].s = th;
    setAs(newAS);
  };

  const TextHandler = (e, th) => {
    let newAS = JSON.parse(JSON.stringify(as));
    newAS[aN].s[th] = e.target.value;
    if (
      newAS[aN].s[0] == "" ||
      newAS[aN].s[1] == "" ||
      newAS[aN].s[2] == "" ||
      newAS[aN].s[3] == false
    ) {
      setError(true);
      setShowModal(false);
    } else {
      setError(false);
      setShowModal(false);
    }
    setAs(newAS);
  };

  const RangeHandler = (e) => {
    let newAS = JSON.parse(JSON.stringify(as));
    newAS[aN].s = e.target.value;
    setAs(newAS);
  };

  return (
    <div className="min-h-[calc(100vh-305.19px)] mt-[24px] w-full">
      <div className="py-5">
        <div className="max-w-[540px] lg:max-w-[960px] md:max-w-[720px] sm:max-w-[540px] m-auto px-[15px]">
          <div className="max-w-[900px] mx-auto">
            <span className="text-[#0060CE] text-xl font-medium mb-5">
              {aN + 1} / 9
            </span>
            <div className="w-full rounded bg-[#d9dfe4] h-[10px]">
              <div
                className={`bg-[#0060CE] rounded h-full duration-500 ease-in-out ${
                  aN == 1
                    ? "w-1/8"
                    : aN == 2
                    ? "w-2/8"
                    : aN == 3
                    ? "w-3/8"
                    : aN == 4
                    ? "w-4/8"
                    : aN == 5
                    ? "w-5/8"
                    : aN == 6
                    ? "w-6/8"
                    : aN == 7
                    ? "w-7/8"
                    : aN == 8
                    ? "w-8/8"
                    : "w-0"
                }`}
              ></div>
            </div>
            <h3 className="font-normal text-[#004d9b] pt-5 text-3xl text-center mb-5">
              {as[aN].q}
            </h3>
            <p className="text-[#6c757d] text-center text-base mb-5">
              {as[aN].sub}
            </p>

            <div className="flex flex-col">
              {as[aN].type == "m" ? (
                <div className="mx-auto">
                  {as[aN].a.map((data) => (
                    <div key={`${aN}-${data[1]}`} className="form-check mb-5">
                      <input
                        className="form-check-input mr-1"
                        type="checkbox"
                        checked={as[aN].s[data[1]]}
                        onChange={(e) => CheckBoxHandler(e, data[1])}
                      />
                      <label className="form-check-label">{data[0]}</label>
                    </div>
                  ))}
                </div>
              ) : as[aN].type == "s" ? (
                <div className="mx-auto">
                  {as[aN].a.map((data) => (
                    <div key={`${aN}-${data[1]}`} className="form-check mb-5">
                      <input
                        className="form-check-input mr-1"
                        type="radio"
                        checked={as[aN].s == data[1]}
                        onChange={(e) => RadioHandler(e, data[1])}
                      />
                      <label className="form-check-label">{data[0]}</label>
                    </div>
                  ))}
                </div>
              ) : as[aN].type == "p" ? (
                <div className="mx-auto w-full">
                  <input
                    type="range"
                    value={as[aN].s}
                    min="0"
                    max={as[aN].a}
                    className="form-control-range w-full mb-5 border-none"
                    name="range"
                    onChange={RangeHandler}
                  />
                  {aN == 4 && "$"}
                  {as[aN].s}
                </div>
              ) : as[aN].type == "f" ? (
                <div className="mx-auto">
                  <input
                    type="text"
                    className="border mb-4 p-2"
                    placeholder={as[aN].a[0][0]}
                    value={as[aN].s[0]}
                    onChange={(e) => TextHandler(e, 0)}
                  />
                  <br />
                  <input
                    type="text"
                    className="border mb-4 p-2"
                    placeholder={as[aN].a[1][0]}
                    value={as[aN].s[1]}
                    onChange={(e) => TextHandler(e, 1)}
                  />
                  <br />
                  <input
                    type="text"
                    className="border mb-4 p-2"
                    placeholder={as[aN].a[2][0]}
                    value={as[aN].s[2]}
                    onChange={(e) => TextHandler(e, 2)}
                  />
                  <br />
                  <input
                    type="checkbox"
                    className="form-check-input mr-1"
                    checked={as[aN].s[3]}
                    onChange={(e) => CheckTermHandler(e, 3)}
                  />
                  <span>{as[aN].a[3][0]}</span>
                  <span>{as[aN].a[4][0]}</span>
                </div>
              ) : (
                <div></div>
              )}
              {as[aN].o && (
                <div className="form-group mx-auto">
                  <span className="mb-5 mx-auto">If you select other</span>
                  <br />
                  <textarea
                    className="form-control mb-5 mx-auto w-[300px] h-[100px]"
                    placeholder={as[aN].o}
                  ></textarea>
                </div>
              )}
            </div>
            <div className="flex flex-col sm:flex-col md:flex-row lg:flex-row justify-end mt-5 gap-3">
              {aN != 0 && (
                <button
                  className="font-bold px-[15px] py-[10px] min-w-[180px] text-[18px] text-[#fff] bg-gradient-to-r from-[#1898cb] to-[#35c9ff] rounded hover:from-[#0888bb] hover:to-[#25b9ef]"
                  onClick={PrevClick}
                >
                  Previous
                </button>
              )}
              {aN != 8 && (
                <button
                  className="font-bold px-[15px] py-[10px] min-w-[180px] text-[18px] text-[#fff] bg-gradient-to-r from-[#35c9ff] to-[#1898cb] rounded hover:from-[#25b9ef] hover:to-[#0888bb]"
                  onClick={NextClick}
                >
                  Next
                </button>
              )}
              {aN == 8 && (
                <>
                  <button
                    type="button"
                    className={`font-bold px-[15px] py-[10px] min-w-[180px] text-[18px] text-[#fff] bg-gradient-to-r from-[#35c9ff] to-[#1898cb] rounded hover:from-[#25b9ef] hover:to-[#0888bb] ${
                      error && "bg-gray-400"
                    }`}
                    onClick={() => setShowModal(true)}
                  >
                    Submit
                  </button>

                  {!error && showModal && (
                    <>
                      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-auto my-6 mx-auto max-w-3xl">
                          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                            <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                              <h3 className="text-3xl text-[#0060CE] font-semibold">
                                Thank you for taking the questionnaire
                              </h3>
                              <button
                                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                onClick={() => setShowModal(false)}
                              >
                                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                  ×
                                </span>
                              </button>
                            </div>

                            <div className="relative p-6 flex-auto">
                              <p className="my-4 text-slate-500 text-lg leading-relaxed">
                                We received your responses. We'll get back to
                                you within 1-2 business days via email about
                                your personalized marketing recommendation.
                              </p>
                            </div>

                            <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                              <span className="background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150">
                                Please hold. You are being redirected to the
                                HandL UTM Grabber V3 website in 10 seconds...
                              </span>
                              <button
                                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button"
                                onClick={() => setShowModal(false)}
                              >
                                Go now
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeUtmAudit;
